import colors from '../colors';

const theme = (corPrimaria: string) => ({
  colors: {
    primaria: corPrimaria,
    secundaria: colors.SECUNDARIA,
    background: colors.BACKGROUND,
    backgroundAlternativo: colors.BACKGROUNDALT,
    fontePadrao: colors.FONTEPADRAO,
    fonteLight: colors.FONTEALT,
    error: colors.ERROR,
    success: colors.SUCCESS
  }
})

export default theme;
